export const GRAPH_ATTENDANCE_LOADING = "GRAPH_ATTENDANCE_LOADING";
export const GRAPH_ATTENDANCE_SUCCESS = "GRAPH_ATTENDANCE_SUCCESS";
export const GRAPH_ATTENDANCE_ERROR = "GRAPH_ATTENDANCE_ERROR";

export const GRAPH_RESULT_LOADING = "GRAPH_RESULT_LOADING";
export const GRAPH_RESULT_SUCCESS = "GRAPH_RESULT_SUCCESS";
export const GRAPH_RESULT_ERROR = "GRAPH_RESULT_ERROR";
